import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/travis/build/cool-hooks/react-wordpress-hooks/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "wordpressprovider"
    }}>{`WordPressProvider`}</h2>
    <h4 {...{
      "id": "props"
    }}>{`Props`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`url`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`URL of WordPress website`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`headers`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Headers`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Fetch headers`}</td>
        </tr>
      </tbody>
    </table>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// index.js

import React from 'react';
import ReactDOM from 'react-dom';
import { WordPressProvider } from 'react-wordpress-hooks';

import App from './App';

const headers = new Headers();

headers.append(
  'Authorization',
  \`Basic \${btoa('your.email@example.com:y0ur-p@ssw0rd-hErE')}\`
);

ReactDOM.render(
  <WordPressProvider
    config={{
      url: 'https://example.com',
      headers,
    }}
  >
    <App />
  </WordPressProvider>,
  document.getElementById('root')
);
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      